import { render, staticRenderFns } from "./CtaAccount.vue?vue&type=template&id=069923ac&lang=pug"
import script from "./CtaAccount.vue?vue&type=script&lang=js"
export * from "./CtaAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports